// Copyright (c) 2020 Deere & Company

import t from 'tcomb';

const SapStatus = t.struct({
    isSapUp: t.Boolean,
    lastChecked: t.Number
},
    {
        name: 'SapStatus',
        strict: false
    });

export const getDefaultState = () =>
    new SapStatus({
        isSapUp: true,
        lastChecked: 0
    });

export default SapStatus;



// WEBPACK FOOTER //
// ./src/shared/state/sap-Status.js